import styled from 'styled-components';
import { palette } from 'styles/colors';
import React from 'react'
import Slider from 'react-slick'
import { layout } from 'styles/layout'

interface VisibleItemProps {
  visible: boolean
}

export const CoursesCarouselSection = styled.div`
  position: relative;
  // This property is important to overwrite default width from container which is not full width
  max-width: 100vw !important;
`

export const CoursesCarouselContainer = styled.div`
  position: relative;
  @media screen and (min-width: ${layout.subLg}) {
    padding-top: 100px;
  }
`

export const CoursesCarouselShapeBackground = styled.div`
  position: absolute;
  height: 100%;
  background-image: url(data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE0NDAgNDk0Ljk4Ij48cGF0aCBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiIGZpbGw9IiM4MGQxY2QiIG9wYWNpdHk9Ii4xIiBkPSJNMCAwdjQ5NC45OGgxNDQwdi0yNy4zMWwtMTk4LjY2LTI5OC45MUwwIDB6Ii8+PC9zdmc+);
  background-position: top;
  background-size: auto 36vw;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // These two property are important to overwrite the default margin and width from container
  max-width: 100vw !important;
  margin-top: -100px !important;
  &:after {
    position: absolute;
    left: 0;
    bottom: -100px;
    content: " ";
    width: 100%;
    // Adds the 100px negative from bottom property
    height: calc(100% - 36vw + 100px);
    background-color: ${palette.blackSqueeze};
    z-index: -2;
  }
`

export const CoursesCarouselHeadingContainer = styled.div`
  display: block;
  max-width: 1024px;
  padding: 0 2.5rem;
  margin: 0 auto 1em;
  box-sizing: border-box;

  & > h1 {
    margin: 0 auto 1em;
    max-width: 90%;

    @media all and (max-width: 950px) {
      max-width: 100%;
    }
  }

  @media all and (max-width: 600px) {
    padding: 0 1.5rem;
  }
  @media all and (max-width: ${layout.xs}) {
    padding: 2rem 1.5rem 0;
  }
`

export const CoursesImagesSliderContainer = styled.div`
  display: block;
  position: relative;
  overflow: visible;
  width: 100%;
  max-width: 400px !important;
  margin: 0 auto;
`

export const CoursesImageSlider = styled(Slider)`
  > div:first-of-type {
    overflow: visible;
  }
`

export const LeftArrow = styled.svg.attrs({
  width: 15,
  height: 30,
  viewBox: '0 0 15 30',
  children: <path d="M11.785 27.607a1.333 1.333 0 01-2.236 1.453L.882 15.727a1.333 1.333 0 010-1.454L9.55.94a1.333 1.333 0 112.236 1.453L3.59 15l8.195 12.607z" fill="#2D263B" />
})`
  z-index: 6;
  top: 40%;
  left: 30px;
`

export const RightArrow = styled.svg.attrs({
  width: 12,
  height: 30,
  viewBox: '0 0 12 30',
  children: <path d="M.882 27.607L9.076 15 .882 2.393A1.333 1.333 0 013.118.94l8.667 13.333a1.333 1.333 0 010 1.454L3.118 29.06a1.333 1.333 0 01-2.236-1.453z" fill="#2D263B" />
})`
  z-index: 6;
  top: 40%;
  right: 30px;
  left: initial;
`

export const ImageContainer = styled.div<VisibleItemProps>`
  ${({ visible }) => visible && 'transform: scale(1.1);'}
  transition: transform ease-in-out 300ms;
  grid-area: home-phone;
  opacity: 1;
  position: relative;
  justify-self: center;
  align-self: center;
  filter: drop-shadow(rgba(0,39,74,0.3) 8px 8px 67px);
  width: 192px;
  height: 395px;
  margin: 40px auto 60px;

  @media screen and (max-width: ${layout.subMd}) {
    width: 166px;
    margin: 64px auto;
    height: 333px;
  }
`

export const PhoneBlockImageTop = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: ${palette.white};
  height: 6%;
  width: 44%;
  border-radius: .5rem;
`

export const ImageShadow = styled.div`
  width: 90%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  padding: 5%;

  img {
    border-radius: 1.2rem;
  }
`

// absolute positioning extends div outside of parent padding's, calc and 1em is used to render it inside padding
export const ImageCaptionContainer = styled.div<VisibleItemProps>`
  opacity: ${({ visible }) => visible ? '1' : '0'};
  color: ${palette.black};
  padding: 0 1.5em 1.5em;
  box-sizing: border-box;
  transition: all ease-in-out 300ms;

  @media screen and (min-width: ${layout.subLg}) {
    opacity: 1;
  }
`

export const CoursesCarouselButtonContainer = styled.div`
  display: grid;
  padding-top: 1em;
  row-gap: 2em;
`
